import type { Payment } from 'paintscout'
import { isWisetackPayment } from './is-wisetack-payment'

/**
 * A failed Wisetack payout is a loan Wisetack cancelled or declined, not a failed charge, so its
 * badge says so instead of "Failed" (ENG-1724). The webhook stores the status in failedEvents.
 * Returns null for anything else, so callers fall back to the generic status label.
 */
export function getWisetackFailedLabel(
  payment: Pick<Payment, 'type' | 'status' | 'failedEvents'>
): 'Cancelled' | 'Declined' | null {
  if (payment?.status !== 'failed' || !isWisetackPayment(payment as Payment)) return null
  return payment.failedEvents?.includes('DECLINED') ? 'Declined' : 'Cancelled'
}
